import type { FC } from 'react'
import styled from 'styled-components'
import { UserBlockPopover } from './UserBlockPopover'
import { Button } from 'antd'
import { getWindowBasePath } from 'shared/utils/getWindowBasePath'
import { Avatar } from 'fronton-react'
import { getLogoutLink, parseJwt } from 'shared/utils'
import { useSelector } from 'react-redux'
import { userInfoSelector } from 'redux/selectors'

const StyledUserBlockPopover = styled(UserBlockPopover)`
    .ant-popover-title {
        padding: 15px;
    }

    .ant-popover-inner-content {
        padding: 0;
        width: 100%;
    }

    .ant-popover {
        z-index: 9999;
    }
`

const UserWrapper = styled.div`
    transition: background-color ease-in-out 0.2s;

    // &:hover {
    //     background-color: ${({ theme }) => theme.secondDarkColor};
    //     cursor: pointer;
    // }
`

export const LogOutButton = styled(Button)`
    height: 50px;
    width: 100%;
    color: #000;
    text-transform: uppercase;
    border: none;
    background-color: #fdc300;
    &:focus {
        background-color: ${({ theme }) => theme.secondDarkColor};
        border: none;
    }
    &:hover {
        background-color: #e79f26;
        border: none;
        color: #fff;
    }
`

const UserName = styled.label`
    font-size: 16px;
`

export const UserBlock: FC = () => {
    const userInfo = useSelector(userInfoSelector)
    const { token } = userInfo
    const { name } = parseJwt(token)

    // useEffect(() => {
    //     if (!lsUser) {
    //         if (typeof window !== 'undefined' && window.location.pathname !== '/') {
    //             window.location.href = '/'
    //         }
    //     }
    // }, [lsUser])

    const handleLogOutClick = () => {
        localStorage.clear()
        window.location.href = `${getLogoutLink()}${getWindowBasePath()}`
    }

    const popoverText = <UserName>{name}</UserName>

    const popoverContent = (
        <LogOutButton block={true} type="primary" htmlType="button" onClick={handleLogOutClick}>
            Выйти
        </LogOutButton>
    )

    return (
        <StyledUserBlockPopover
            placement="bottomRight"
            content={popoverContent}
            title={popoverText}
            trigger="click"
            getPopupContainer={() => document.body}
        >
            <UserWrapper>
                {name && (
                    <Avatar
                        color="default"
                        description="Сотрудник Леруа Мерлен Восток"
                        hideInfo
                        name={name}
                        overflow="multiline"
                        size="m"
                        variant="fill"
                        style={{ cursor: 'pointer' }}
                    />
                )}
            </UserWrapper>
        </StyledUserBlockPopover>
    )
}
